import { render, staticRenderFns } from "./TableCampaignContacts.vue?vue&type=template&id=6813f000&scoped=true&"
import script from "./TableCampaignContacts.vue?vue&type=script&lang=js&"
export * from "./TableCampaignContacts.vue?vue&type=script&lang=js&"
import style0 from "./TableCampaignContacts.vue?vue&type=style&index=0&id=6813f000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6813f000",
  null
  
)

export default component.exports